/**
 * What every tab of Activity shares — `docs/activity.md` §6.6: one set of
 * people for every tab, the remembered state, the people lists, and the
 * figures the tab counts and the nav badge read.
 */
import { createContext, useContext } from 'react'
import type {
  ActivityGroup, ActivityState, MeResponse, PeopleDirectory, StoredActivityState,
} from '@rowted/shared'

export interface ActivityBadge {
  unread: number
  dueOrLate: number
}

export interface ActivityContextValue {
  me: MeResponse
  state: ActivityState
  change: (patch: StoredActivityState, options?: { now?: boolean }) => void
  /** The people lists (`GET /activity/people`) — null while loading. */
  directory: (PeopleDirectory & { groups: ActivityGroup[] }) | null
  reloadDirectory: () => void
  /** The people shown, in the people button's order (a group's members when one is picked). */
  people: string[]
  /** The branches whose Unassigned is picked. */
  unassigned: string[]
  badge: ActivityBadge | null
  reloadBadge: () => void
  /** Today, as the server reads it for this person. */
  today: string
}

export const ActivityContext = createContext<ActivityContextValue | null>(null)

export function useActivity(): ActivityContextValue {
  const value = useContext(ActivityContext)
  if (!value) throw new Error('useActivity outside the Activity page')
  return value
}
